const translationsEn = {
    "FOOTER_RIGHT_TEXT"                 : "This site uses cookies"
};

export default translationsEn;
